import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentMethodPendingService } from './payment-method-pending.service';
import { AccountStatusPaymentMethodStatusDto } from '@well/domain';
import { PaymentMethodPendingViewComponent } from '../payment-method-pending-view/payment-method-pending-view.component';
import { EMPTY, switchMap, tap } from 'rxjs';

@Component({
  selector: 'well-payment-method-pending',
  standalone: true,
  imports: [CommonModule, PaymentMethodPendingViewComponent],
  templateUrl: './payment-method-pending.component.html',
  styleUrls: ['./payment-method-pending.component.scss'],
})
export class PaymentMethodPendingComponent{

  @Output() retryPayment: EventEmitter<void> = new EventEmitter<void>();

  @Output() confirmPayment: EventEmitter<void> = new EventEmitter<void>();

  @Output() missingPendingPayment: EventEmitter<void> = new EventEmitter<void>();

  currentPaymentStatus: AccountStatusPaymentMethodStatusDto | null = null;

  constructor(private paymentMethodPendingService: PaymentMethodPendingService) {
  }

  onCheckStatus(){
    this.paymentMethodPendingService.getPendingPaymentMethodStatus().pipe(
      tap((res) => {
        this.currentPaymentStatus = res.data;
      }),
      switchMap(() => {
        if(this.currentPaymentStatus?.status === 'CONFIRMED'){
          return this.paymentMethodPendingService.confirmPaymentMethod();
        }
        else{
          if(!this.currentPaymentStatus){
            this.missingPendingPayment.emit();
          }
          return EMPTY;
        }
      })
    ).subscribe(() => {
      if(this.currentPaymentStatus?.status === 'CONFIRMED'){
        this.confirmPayment.emit();
      }
    })
  }

  onRetryPayment(){
    this.paymentMethodPendingService.unlinkPendingPaymentMethodFromAccountStatus().subscribe(() => {
      this.retryPayment.emit();
    })
  }

}
